import React from 'react';
import { useField } from '@unform/core';

import {
  Button,
  TextField,
  WrapperFlex,
  TelefoneBox,
} from '@unimed-fesp/components';

import { isEmail, isCNPJ } from '../../../utils/validation';
import { Container, IconNext } from './styles';

function FormMassaInicial({
  dadosEmpresa,
  setDadosEmpresa,
  formRef,
  clearInputs,
  handleAvancar,
}) {
  const registerEmpresa = useField('empresa').registerField;
  const registerResponsavel = useField('responsavel').registerField;
  const registerEmail = useField('email').registerField;
  const registerCNPJ = useField('cnpj').registerField;
  const errorEmail = useField('email').error;
  const errorCNPJ = useField('cnpj').error;
  const errorResponsavel = useField('responsavel').error;
  const errorEmpresa = useField('empresa').error;

  const canSubmit =
    !!dadosEmpresa.responsavel &&
    !errorResponsavel &&
    !!dadosEmpresa.empresa &&
    !errorEmpresa &&
    !!dadosEmpresa.email &&
    !errorEmail &&
    !!dadosEmpresa.cnpj &&
    !errorCNPJ;

  const validateInput = (e) => {
    if (!formRef) return;

    const { name, value } = e.target;
    formRef.setFieldError(name, '');

    if (name === 'cnpj' && !isCNPJ(value)) {
      formRef.setFieldError(name, `O cnpj não é válido`);
    }

    if (name === 'email' && !isEmail(value)) {
      formRef.setFieldError(name, `O email não é válido`);
    }

    if ((name === 'empresa' || name === 'responsavel') && value.length > 100) {
      formRef.setFieldError(name, `O campo só pode ter 100 caracteres`);
    }

    if (!value) {
      formRef.setFieldError(name, `O campo é obrigatório`);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDadosEmpresa((dados) => ({
      ...dados,
      [name]: name === 'cnpj' ? value.replaceAll(/\D/g, '') : value,
    }));
  };

  const formatCNPJ = (cnpj) => {
    let cnpjNumber = cnpj.replaceAll(/[^\d]/g, '');

    if (cnpjNumber.length >= 14) cnpjNumber = cnpjNumber.substr(0, 14);

    if (cnpjNumber.length > 12)
      cnpjNumber = cnpjNumber.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d)/g,
        '$1.$2.$3/$4-$5'
      );
    else if (cnpjNumber.length > 8)
      cnpjNumber = cnpjNumber.replace(
        /^(\d{2})(\d{3})(\d{3})(\d)/g,
        '$1.$2.$3/$4'
      );
    else if (cnpjNumber.length > 5)
      cnpjNumber = cnpjNumber.replace(/^(\d{2})(\d{3})(\d)/g, '$1.$2.$3');
    else if (cnpjNumber.length > 2)
      cnpjNumber = cnpjNumber.replace(/^(\d{2})(\d)/g, '$1.$2');

    return cnpjNumber;
  };
  return (
    <>
      <WrapperFlex column justifyStart>
        <Container>
          <TextField
            name="empresa"
            labelText="Empresa"
            placeholder="Informe o nome da sua empresa"
            width={414}
            marginLeft={1}
            marginBottom={15}
            value={dadosEmpresa.empresa}
            onChange={(e) => handleChange(e)}
            onBlur={(e) => validateInput(e)}
            error={errorEmpresa}
            errorMessage={errorEmpresa}
            register={registerEmpresa}
          />
          <TextField
            name="cnpj"
            labelText="CNPJ"
            placeholder="Informe o CNPJ da sua empresa"
            width={400}
            marginLeft={1}
            marginBottom={15}
            value={formatCNPJ(dadosEmpresa.cnpj)}
            onChange={(e) => handleChange(e)}
            onBlur={(e) => validateInput(e)}
            register={registerCNPJ}
            error={errorCNPJ}
            errorMessage={errorCNPJ}
          />
          <TextField
            name="responsavel"
            labelText="Responsável"
            placeholder="Informe o seu nome ou o da pessoa responsável"
            width={458}
            marginLeft={1}
            marginBottom={15}
            value={dadosEmpresa.responsavel}
            onChange={(e) => handleChange(e)}
            onBlur={(e) => validateInput(e)}
            register={registerResponsavel}
            error={errorResponsavel}
            errorMessage={errorResponsavel}
          />
          <TextField
            name="email"
            labelText="E-mail"
            placeholder="Informe o seu e-mail ou o da pessoa responsável"
            width={404}
            marginLeft={1}
            marginBottom={15}
            value={dadosEmpresa.email}
            onChange={(e) => handleChange(e)}
            onBlur={(e) => validateInput(e)}
            register={registerEmail}
            error={errorEmail}
            errorMessage={errorEmail}
          />
          <TelefoneBox
            contatos={dadosEmpresa.telefone.contatos}
            callbackChangeContatos={(contatos) =>
              setDadosEmpresa((state) => ({
                ...state,
                telefone: { contatos },
              }))
            }
            single
          />
        </Container>
        <WrapperFlex justifySpaceBetween marginTop={30}>
          <Button
            tipo="secondary"
            paddingBottom={8}
            paddingTop={8}
            paddingRight={8}
            paddingLeft={8}
            width={100}
            type="button"
            alignCenter
            justifyCenter
            onClick={clearInputs}
            font="16px unimed_slabregular"
          >
            limpar
          </Button>
          <Button
            tipo="primary"
            paddingBottom={8}
            paddingTop={8}
            paddingRight={8}
            paddingLeft={8}
            width={100}
            type="button"
            alignCenter
            justifyCenter
            disabled={!canSubmit}
            onClick={() => handleAvancar()}
            font="16px unimed_slabregular"
          >
            avançar
            <IconNext />
          </Button>
        </WrapperFlex>
      </WrapperFlex>
    </>
  );
}

export default FormMassaInicial;
